import '../style/modal-flow-DMlN848d.css'
import { defineComponent as H, useModel as R, provide as B, computed as P, watch as z, createVNode as h, mergeProps as b, Transition as G, KeepAlive as J, toRaw as Q, ref as X, getCurrentInstance as Y, inject as T } from "vue";
import Z from "./modal.js";
import { useState as m } from "./hooks/useState.js";
import { useUnWrapValue as j } from "./hooks/useUnWrapValue.js";
import { useMergedWatch as $ } from "./hooks/useMergedWatch.js";
const ee = (e) => {
  const l = e.map((s) => s.status), c = Array.from(new Set(l));
  if (l.length !== c.length) throw new Error("The `status` field of modal-flow step object should be unique.");
  let n = !1;
  e.forEach((s) => {
    if (s.keepAlive !== void 0 && (n = !0), n && !s.componentName) throw new Error("The `componentName` field of modal-flow step object could not be empty when you set the `keepAlive` field in any step.");
  });
}, ne = /* @__PURE__ */ H({
  name: "e-modal-flow",
  props: {
    modelValue: {
      type: Boolean,
      required: !1,
      default: !1
    },
    steps: {
      type: Array,
      default: () => []
    },
    defaultStatus: {
      type: [String, Number]
    },
    modalProps: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    cacheStateOnClose: Boolean,
    historyMode: Boolean,
    keepAlive: Boolean,
    onProceed: Function,
    onDrawback: Function,
    onChange: Function,
    onClose: Function
  },
  setup(e, {
    expose: l,
    slots: c,
    emit: n
  }) {
    ee(e.steps);
    const [s, O] = m(e.steps), k = R(e, "modelValue", {
      local: !0
    }), [i, w] = m([]), [d, V] = m(e.defaultStatus ?? e.steps[0]?.status), [v, M] = m({}), [U, A] = m([]), [q, g] = m(!1);
    B("prevValue", U), B("stepValues", v);
    const F = (t) => {
      k.value = t;
    }, I = P(() => ({
      ...e.modalProps,
      ...s.value.find((t) => d.value === t.status)?.props || {}
    })), L = P(() => {
      const t = e.keepAlive, a = [];
      return s.value.forEach((o) => {
        o.componentName && (t ? (o.keepAlive ?? !0) && a.push(o.componentName) : o.keepAlive && a.push(o.componentName));
      }), {
        include: a
      };
    });
    $(e, {
      steps: () => {
        throw new Error("Please don't set a new steps object directly. We only support update specific modal props.");
      }
    }), z(k, (t) => {
      t || (w([]), e.cacheStateOnClose || V(e.defaultStatus || e.steps[0]?.status), e?.onClose?.());
    });
    const C = () => {
      F(!1);
    }, E = (t, ...a) => {
      const o = s.value.find((p) => p.status === d.value);
      if (!s.value.find((p) => t === p.status)) throw new Error("The status you set is invalid.");
      g(!0), e?.onChange?.(d.value, t, I.value, ...a), V(t), A(a), M({
        ...v.value,
        [d.value]: a
      });
      const r = [...i.value].concat(o);
      w(r), g(!1);
    }, x = (t, a, o, ...u) => {
      e?.onChange?.(t, a, o, ...u), q.value || (V(a), A(u), M({
        ...v.value,
        [t]: u
      })), g(!1);
    }, N = (t, a) => {
      const o = s.value.map((u) => t === u.status ? {
        ...u,
        props: a
      } : u);
      O(o);
    }, _ = (...t) => {
      const a = s.value.findIndex((S) => S.status === d.value), {
        status: o,
        props: u = {}
      } = s.value[a];
      if (a === s.value.length - 1) {
        M({
          ...v.value,
          [o]: t
        });
        return;
      }
      const r = s.value[a + 1].status;
      e?.onProceed?.(o, r, u, ...t), x(o, r, u, ...t);
      const p = [...i.value].concat(s.value[a]);
      w(p);
    }, D = (...t) => {
      const a = s.value.findIndex((y) => y.status === d.value), {
        status: o,
        props: u = {}
      } = s.value[a], {
        historyMode: r
      } = e;
      if (r && !i.value.length && a === 0 || !r && a === 0) return;
      const p = s.value[a - 1]?.status, S = r && i.value.length ? i.value[i.value.length - 1].status : p;
      e?.onDrawback?.(o, S, u, ...t), x(o, S, u, ...t);
      const f = [...i.value];
      f.pop(), w(f);
    }, W = () => s.value.map((t) => {
      const {
        component: a,
        status: o,
        componentProps: u
      } = t, r = Q(a), p = P(() => u?.() ?? {});
      return {
        status: o,
        comp: h(r, b({
          key: o,
          onProceed: _,
          onDrawback: D,
          onModalClose: C,
          onSetStatus: E,
          onUpdateProps: (f) => N(o, f),
          onModalFlowEmit: (f, ...y) => {
            n(f, ...y);
          }
        }, p.value), null)
      };
    });
    l({
      updateModalProps: N,
      setStatus: E,
      setModalState: F,
      closeModal: C,
      drawback: (...t) => {
        const a = s.value.findIndex((o) => o.status === d.value);
        D(a, ...t);
      },
      proceed: (...t) => {
        const a = s.value.findIndex((o) => o.status === d.value);
        _(a, ...t);
      },
      getStepsValue: () => j(v.value),
      getStepValue: (t) => j(v.value[t])
    });
    const K = P(() => {
      const t = W().find((a) => a.status === d.value);
      return c[d.value] ? c[d.value]?.() : t?.comp;
    });
    return () => h(Z, b({
      class: "e-modal-flow",
      modelValue: k.value
    }, I.value, {
      onClose: C
    }), {
      default: () => [h(G, {
        name: "slide-right",
        mode: "out-in"
      }, {
        default: () => [h("div", {
          class: "e-modal-flow-container"
        }, [h(J, b(L.value, {
          key: "keepAlive"
        }), [K.value])])]
      })]
    });
  }
});
function ue() {
  const e = X();
  return [
    e,
    {
      updateModalProps: (l, c) => {
        e.value?.updateModalProps?.(l, c);
      },
      setStatus: (l, ...c) => {
        e.value?.setStatus?.(l, ...c);
      },
      setModalState: (l) => {
        e.value?.setModalState?.(l);
      },
      closeModal: () => {
        e.value?.closeModal?.();
      },
      proceed: (...l) => {
        e.value?.proceed?.(...l);
      },
      drawback: (...l) => {
        e.value?.drawback?.(...l);
      },
      getStepsValue: () => e.value?.getStepsValue(),
      getStepValue: (l) => e.value?.getStepValue(l)
    }
  ];
}
const ce = ["proceed", "drawback", "modal-close", "set-status", "update-props", "modal-flow-emit"];
function de() {
  const e = Y(), l = T("prevValue"), c = T("stepValues");
  return {
    prevValue: l,
    stepValues: c,
    getPrevValue: () => l?.value,
    getStepsValue: () => c?.value,
    getStepValue: (n) => c?.value[n],
    proceed: (...n) => e?.emit("proceed", ...n),
    drawBack: (...n) => e?.emit("drawback", ...n),
    closeModal: () => e?.emit("modal-close"),
    setStatus: (n, ...s) => e?.emit("set-status", n, ...s),
    updateProps: (n) => e?.emit("update-props", n),
    emitter: (n, ...s) => {
      e?.emit("modal-flow-emit", n, ...s);
    }
  };
}
export {
  ce as MODAL_FLOW_STEP_EVENTS,
  ne as default,
  ue as useModalFlow,
  de as useModalFlowStep
};
//# sourceMappingURL=modal-flow.js.map
